import Button from "components/Button";
import Content from "components/Content";
import Label from "components/Label";
import text from "constants/text";
import useScreenSize from "hooks/use-screen-size";
import Image from "next/image";
import { useRouter } from "next/router";
import React, { FC } from "react";

import styles from "./styles.module.scss";

const HowItWorks: FC = () => {
  const { title, steps } = text.vendors.how_it_works;
  const { isResponsive, isMobile } = useScreenSize();

  const router = useRouter();

  return (
    <Content
      contentClassName={styles.container}
      containerClassName={styles.wrapper}
    >
      <Label variant="h-centered" color="white" className={styles.title}>
        {title}
      </Label>
      <div className={styles.steps}>
        {steps.map(
          (
            {
              title: sTitle,
              description: sDescription,
              action,
              image,
              snippet
            },
            index
          ) => (
            <div className={styles.item}>
              <div className={styles.leftPanel}>
                <Label
                  color="white"
                  variant="s"
                  className={styles.stepNumber}
                >{`0${index + 1}`}</Label>
                <Label variant="h" color="white" className={styles.sTitle}>
                  {sTitle}
                </Label>
                <Label
                  variant="s"
                  color="white"
                  className={styles.sDescription}
                >
                  {sDescription}
                </Label>
                {action && (
                  <Button variant="cta" onClick={() => router.push(action.to)}>
                    {action.reads}
                  </Button>
                )}
              </div>
              <div className={styles.rightPanel}>
                <div className={styles.image}>
                  {snippet && (
                    <Image
                      alt=""
                      src={snippet}
                      layout="fixed"
                      width={isResponsive ? (isMobile ? 120 : 120) : 200}
                      height={isResponsive ? (isMobile ? 140 : 145) : 240}
                      className={styles.snippet}
                    />
                  )}
                  <Image alt="" objectFit="cover" layout="fill" src={image} />
                </div>
              </div>
            </div>
          )
        )}
      </div>
    </Content>
  );
};

export default HowItWorks;
